import { Undo } from "@mui/icons-material";
import { Badge, IconButton } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useRecoilState } from "recoil";
import { previousRouteAtom, userProfileAtom } from "../../../recoil/atoms";
import { displayRequestsAtom } from "../utils/requestAtoms";
import NotificationsIcon from '@mui/icons-material/Notifications';
import usePopover from "./usePopover";
import NotificationElementPopover from "./NotificationElementPopover";
import { useCallback, useEffect } from "react";
import useRequestNotificationUtils from "../hooks/useRequestNotificationUtils";
import { IUser } from "../../../common-interfaces/interfaces";

const NotificationButton = () => {
  const [previousRoute, setPreviousRoute] = useRecoilState(previousRouteAtom)
  const [displayRequests] = useRecoilState(displayRequestsAtom)
  const [user] = useRecoilState<IUser | undefined>(userProfileAtom)
  const { getPendingRequestsReceived } = useRequestNotificationUtils()
  const navigate = useNavigate();
  const currentRoute = useLocation()
  const notificationPopover = usePopover()


  const handlePreviousRoute = async (event: any) => {
    event.preventDefault()
    navigate(previousRoute);
    setPreviousRoute('/')
  };
  
  const getNotificationLength = useCallback((): number => {
    return getPendingRequestsReceived().length
  }, [user?.username, displayRequests])

  useEffect(() => {
    if (currentRoute.pathname.includes('request')) {
      notificationPopover.close()
    }
  }, [currentRoute.pathname]);


  return (<>{
    currentRoute.pathname.includes('request') ?
      <IconButton
        onClick={handlePreviousRoute}
      >
        <Undo fontSize={"small"} />
      </IconButton> :
      <Badge anchorOrigin={{ vertical: 'top', horizontal: 'right' }} sx={{
        mr: 2, '& .MuiBadge-badge': {
          top: '23%',
          right: '2%',
        },
      }} overlap='circular' variant='standard' badgeContent={getNotificationLength()} color='secondary'>
        <IconButton size='large' edge='end' onClick={(e: any) => notificationPopover.open(e.currentTarget)}>
          <NotificationsIcon />
        </IconButton>
      </Badge>
  }
    {notificationPopover.isOpen && <NotificationElementPopover open={notificationPopover.isOpen} anchorEl={notificationPopover.anchor} onClose={notificationPopover.close} />}
  </>)
}
export default NotificationButton